<p style="font-size: 15px; opacity: 0.8">
    Performance bands for KPIs include Poor, Fair, Good, Very Good, and Excellent. The Poor and
    Excellent ranges will automatically populate based on your inputs.
</p>

<div class="table-container-kpi" style="padding-top: 15px">
    <kendo-grid
        #grid
        [loading]="loading"
        [data]="gridData"
        [sortable]="sortable"
        [scrollable]="'scrollable'"
        [sort]="sort"
        (sortChange)="sortChange($event)"
        [height]="745"
        class="lg-kendo-grid"
        #kendoGrid="kendoGrid"
    >
        <kendo-grid-column
            field="clientKPIDescription"
            title="Key Performance Indicator"
            [width]="280"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                {{ dataItem.clientKPIDescription }}

                <span style="color: red" *ngIf="isInvalid(dataItem)">
                    <p *ngFor="let error of dataItem.errors">{{ error }}</p>
                </span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range1End"
            title="Poor"
            [width]="100"
            [headerStyle]="{ 'background-color': '#fddbdb', 'text-align': 'center' }"
            [style]="{ 'background-color': '#fddbdb', 'padding': '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span style="padding-right: 2px">
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&le;</span>
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&ge;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range1End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range1End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range1End | number)  }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range2Start"
            title="Fair"
            [width]="175"
            [headerStyle]="{ 'background-color': '#fff9e7', 'text-align': 'center' }"
            [style]="{ 'background-color': '#fff9e7', 'padding': '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span>
                    <i
                        class="fas fa-exclamation-circle ng-star-inserted form-error"
                        *ngIf="dataItem.range2StartError"
                    ></i
                ></span>
                <mat-form-field appearance="outline" style="width: 90px; height: 55px">
                    <mat-label>Start</mat-label>
                    <input
                        matInput
                        [(ngModel)]="dataItem.range2Start"
                        type="number"
                        (change)="rangeChange(dataItem, 'range1End', 'range2Start', 'range2StartError', true)"
                        [ngClass]="{ 'form-error': dataItem.range2StartError }"
                    />
                </mat-form-field>

                <span style="padding-left: 9px; padding-right: 7px">-</span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range2End | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range2End | currency: 'USD':'symbol':'1.0-0') : (dataItem.range2End)  }}</span>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range3Start"
            title="Good"
            [width]="285"
            [headerStyle]="{ 'background-color': '#e0f3f3', 'text-align': 'center' }"
            [style]="{ 'background-color': '#e0f3f3', 'padding': '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span>
                    <i
                        class="fas fa-exclamation-circle ng-star-inserted form-error"
                        *ngIf="dataItem.range3StartError || dataItem.range3EndError"
                    ></i>
                </span>

                <mat-form-field
                    appearance="outline"
                    style="width: 90px; height: 55px"
                    [ngClass]="{ 'form-error': dataItem.range3StartError }"
                >
                    <mat-label>Start</mat-label>
                    <input
                        matInput
                        [(ngModel)]="dataItem.range3Start"
                        type="number"
                        (change)="rangeChange(dataItem, 'range2End', 'range3Start', 'range3StartError', true)"
                    />
                </mat-form-field>

                <span
                    style="
                        font-size: 16px;
                        padding-left: 10px;
                        padding-right: 8px;
                        text-align: center;
                    "
                >
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&gt;</span>
                </span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.target | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.target | currency: 'USD':'symbol':'1.0-0') : (dataItem.target)  }}</span>

                <span
                    style="
                        font-size: 16px;
                        padding-left: 8px;
                        padding-right: 10px;
                        text-align: center;
                    "
                >
                    <span *ngIf="dataItem.bestScore == 'Highest'" title="Less Than">&lt;</span>
                    <span *ngIf="dataItem.bestScore == 'Lowest'" title="Greater Than">&gt;</span>
                </span>
                <mat-form-field
                    appearance="outline"
                    style="width: 90px; height: 55px"
                    [ngClass]="{ 'form-error': dataItem.range3EndError }"
                >
                    <mat-label>End</mat-label>
                    <input
                        matInput
                        [(ngModel)]="dataItem.range3End"
                        type="number"
                        (change)="rangeChange(dataItem, 'range4Start', 'range3End', 'range3EndError', false)"
                    />
                </mat-form-field>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range4Start"
            title="Very Good"
            [width]="190"
            [headerStyle]="{ 'background-color': '#f7efff', 'text-align': 'center' }"
            [style]="{ 'background-color': '#f7efff', 'padding': '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span>
                    <i
                        class="fas fa-exclamation-circle ng-star-inserted form-error"
                        *ngIf="dataItem.range4EndError"
                    ></i
                ></span>
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range4Start | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range4Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range4Start)  }}</span>
                <span style="padding-left: 7px; padding-right: 9px">-</span>

                <mat-form-field appearance="outline" style="width: 90px; height: 55px">
                    <mat-label>End</mat-label>
                    <input
                        matInput
                        [(ngModel)]="dataItem.range4End"
                        type="number"
                        (change)="rangeChange(dataItem, 'range5Start', 'range4End', 'range4EndError', false)"
                    />
                </mat-form-field>
            </ng-template>
        </kendo-grid-column>

        <kendo-grid-column
            field="range5Start"
            title="Excellent"
            [width]="120"
            [headerStyle]="{ 'background-color': '#f3f9ed', 'text-align': 'center' }"
            [style]="{ 'background-color': '#f3f9ed', 'padding': '10px 18px' }"
        >
            <ng-template kendoGridCellTemplate let-dataItem let-rowIndex="rowIndex">
                <span *ngIf="dataItem.isPercentage">{{ dataItem.range5Start | number }}%</span>
                <span *ngIf="!dataItem.isPercentage">{{ dataItem.kpiFormat === 'currency' ?  (dataItem.range5Start | currency: 'USD':'symbol':'1.0-0') : (dataItem.range5Start)  }}</span>
                
            </ng-template>
        </kendo-grid-column>
    </kendo-grid>
</div>
